import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";

@Component({
	selector: "modal-orderdetails",
	templateUrl: "./modal-orderdetails.html"
})
export class OrderdetailsModalPage {
	public orderDetails = null;
	public orderData = [];
	 public mainOrder: any = {};

	public all_orders_data = null;

	public columns = [
		{ width: 80, prop: "product", name: "Product" },
		{ width: 50, prop: "sku", name: "Sku" },
		{ width: 50, prop: "price", name: "Price" },
		{ width: 50, prop: "discount", name: "Disc" },
		{ width: 50, prop: "qty", name: "Qty" },
		{ width: 50, prop: "total", name: "Total" }
	];

	constructor(
		public navCtrl: NavController,
		public viewCtrl: ViewController,
		public navParams: NavParams
	) {
		this.orderDetails = this.navParams.get("orderDetails"); 
        this.all_orders_data = this.orderDetails['order_detail_from_offer']; 

		// this.orderDetails["order_details"].forEach(data => {
		// 	this.orderData.push({
		// 		product: data.product_field_app_name,
		// 		sku: data.product_sku,
		// 		price: data.unit_selling_price,
		// 		discount: data.discount,
		// 		qty: data.quantity,
		// 		total: data.item_total_price
		// 	});
		// });
	}

	dismiss() {
		this.viewCtrl.dismiss();
	}
}



// WEBPACK FOOTER //
// ./src/modals/orderdetails/orderdetails.modal.ts